import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import {generate} from "../../../routing/routes";
import {EditButton} from "../../shared/components/Buttons";
import withRouter from "../../../data/shared/withRouter";
import {OPEN} from "../../../data/booking/constants/reservation_status";
import { withTranslation } from "react-i18next";

class EditButtonContainer extends Component {

    static propTypes = {
        data: PropTypes.object
    };

    render() {
        const { data } = this.props;

        if (null == data) {
            return null;
        }

        const isEditable = ('quotation' == this.props.data.type && moment(this.props.data.endAt).isSameOrAfter(moment().startOf('day'))) || ('reservation' == this.props.data.type && this.props.data.status == OPEN)
        if (!isEditable) {
            return null;
        }

        return (
            <EditButton
                onClick={() => this.props.router.navigate(generate('book_edit', {'reference': this.props.data.reference}))}
            >
                {this.props.t('booking.update.addedit')}
            </EditButton>
        );
    }
}

export default withTranslation()(withRouter(EditButtonContainer));
